"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const FormPole = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 17,
  viewBox: "0 0 16 17",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.862.5A2.526 2.526 0 00.336 3.026v10.106a2.526 2.526 0 002.526 2.526h3.369a.842.842 0 100-1.684H2.862a.842.842 0 01-.842-.842V3.026c0-.465.377-.842.842-.842h8.421c.465 0 .842.377.842.842v5.895a.842.842 0 101.685 0V3.026A2.526 2.526 0 0011.283.5h-8.42zm11.132 11.213a.858.858 0 011.245 0 .937.937 0 010 1.291l-3.095 3.21-.016.017a.857.857 0 01-1.269-.025l-1.842-1.911a.937.937 0 010-1.291.858.858 0 011.245 0l1.244 1.29 2.488-2.58zM5.391 6.395a.842.842 0 11-1.684 0 .842.842 0 011.684 0zm-.842 4.209a.842.842 0 100-1.684.842.842 0 000 1.684zm1.684-4.21c0-.464.377-.841.842-.841h2.527a.842.842 0 010 1.684H7.075a.842.842 0 01-.842-.842zm.842 2.526a.842.842 0 100 1.684h2.527a.842.842 0 100-1.684H7.075z",
  className: "fill"
}));

var _default = FormPole;
exports.default = _default;